export const PlayerEmptyPoster = '/img/player/empty_plug.svg'
